module.exports = __webpack_public_path__ + "img/paishe.78331bb5.png";